export const getMenuData = [
  {
    category: true,
    title: 'Administradores',
  },
  {
    title: 'Administradores',
    key: 'administracion',
    icon: 'fa-solid fa-lock',
    count: 4,
    children: [
      {
        title: 'Administradores',
        key: 'admin_list',
        url: '/admin/administradores',
      },
      {
        title: 'Registrar Administrador',
        key: 'registrar_usuario',
        url: '/admin/registrar',
      },
      {
        title: 'Roles y permisos',
        key: 'roles',
        url: '/admin/roles',
      },
      {
        title: 'Registrar rol administrador',
        key: 'registrar_rol',
        url: '/admin/registrarRol',
      },
      /*
      {
        title: 'Mapa',
        key: 'admin_map',
        url: '/admin/mapa',
      },
      */
    ],
  },
  {
    category: true,
    title: 'Mapa de localización',
  },
  {
    title: 'Mapa de localización',
    key: 'mapa',
    icon: 'fa-solid fa-map',
    count: 1,
    children: [
      {
        category: false,
        title: 'Mapa de localización',
        key: 'admin_map',
        url: '/admin/mapa',
      },
    ],
  },
  {
    category: true,
    title: 'Monedero',
  },
  {
    title: 'Monedero',
    key: 'monedero',
    icon: 'fa fa-wallet',
    count: 2,
    children: [
      {
        category: false,
        title: 'Bitácora de movimientos',
        key: 'bitmovs',
        url: '/monedero/movesHistory',
      },
      {
        category: false,
        title: 'Devoluciones',
        key: 'refunds',
        url: '/monedero/refunds',
      },
    ],
  },
  {
    category: true,
    title: 'Concesionarios',
  },
  {
    title: 'Concesionarios',
    key: 'concesionarios',
    icon: 'fa fa-briefcase',
    count: 2,
    children: [
      {
        title: 'Concesionarios',
        key: 'concesionariobuscar',
        url: '/concesionarios/getFranchises',
      },
      /*
      {
        title: 'Registrar Concesionario',
        key: 'concecionarioregistrar',
        url: '/concesionarios/postFranchises',
      },  */
      {
        title: 'Registrar Concesionario',
        key: 'concecionarioregistrar',
        url: '/concesionarios/registrar',
      },
      /*
      {
        title: 'Comprobantes de Pago',
        key: 'concecionarioconsultarpago',
        url: '/concesionarios/getFranchisesPayments',
      },
      {
        title: 'Agregar Créditos de Viaje',
        key: 'concecionarioagregarpago',
        url: '/concesionarios/postFranchisesPayments',
      },
      {
        title: 'Sin Viajes Disponibles',
        key: 'concesionariosinviajes',
        url: '/concesionarios/getFranchisesWithoutTrips',
      },
      */
    ],
  },
  {
    category: true,
    title: 'Accesos para Portal',
  },
  {
    title: 'Accesos para Portal',
    key: 'accesosPortal',
    icon: 'fa-regular fa-user',
    count: 2,
    children: [
      {
        title: 'Accesos para Portal',
        key: 'portalRead',
        url: '/portal/usuarios',
      },
      {
        title: 'Registrar accesos para Portal',
        key: 'portalRegister',
        url: '/portal/registrar',
      },
    ],
  },
  {
    category: true,
    title: 'Concesiones',
  },
  {
    title: 'Concesiones',
    key: 'concesiones',
    icon: 'fa fa-automobile',
    count: 2,
    children: [
      {
        title: 'Concesiones',
        key: 'concesionbuscar',
        url: '/concessions/getConcessions',
      },
      {
        title: 'Registrar Concesión',
        key: 'concesionregistrar',
        url: '/concessions/postConcessions',
      },
    ],
  },
  /*
  {
    category: true,
    title: 'Taxímetros',
  },
  {
    title: 'Taxímetros',
    key: 'taximetros',
    icon: 'fa fa-automobile',
    count: 2,
    children: [
      {
        title: 'Taxímetros',
        key: 'taximetroconsultar',
        url: '/taximeters/getTaximeters',
      },
      {
        title: 'Registrar Taxímetro',
        key: 'taximetroregistrar',
        url: '/taximeters/postTaximeters',
      },
    ],
  },  */
  {
    category: true,
    title: 'Vehículos',
  },
  {
    title: 'Vehículos',
    key: 'vehiculos',
    icon: 'fa fa-automobile',
    count: 4,
    children: [
      {
        title: 'Vehículos',
        key: 'vehículobuscar',
        url: '/vehiculos/getVehicles',
      },
      {
        title: 'Registrar Vehículo',
        key: 'vehiculoregistrar',
        url: '/vehiculos/postVehicles',
      },
      {
        title: 'Tipos de Vehículos',
        key: 'tipovehiculoconsultar',
        url: '/vehiculos/getVehiclesTypes',
      },
      {
        title: 'Registrar Tipo de Vehículo',
        key: 'tipovehiculoregistrar',
        url: '/vehiculos/postVehiclesTypes',
      },
    ],
  },
  {
    category: true,
    title: 'Conductores',
  },
  {
    title: 'Conductores',
    key: 'consuctores',
    icon: 'fa-regular fa-id-card',
    count: 3,
    children: [
      {
        title: 'Conductores',
        key: 'conductorbuscar',
        url: '/conductores/getDrivers',
      },
      {
        title: 'Registrar Conductor',
        key: 'conductorregistrar',
        url: '/conductores/registrar',
      },
      /* {
        title: 'Registrar Conductor 2',
        key: 'createDriver',
        url: '/conductores/registrar',
      }, */
      {
        title: 'Conductores en Línea',
        key: 'conductorcheckin',
        url: '/conductores/getDriversCheckIn',
      },
    ],
  },
  {
    category: true,
    title: 'Viajes',
  },
  {
    title: 'Viajes',
    key: 'viajes',
    icon: 'fa-regular fa-location-dot',
    count: 1,
    children: [
      {
        title: 'Viajes',
        key: 'viajesbuscar',
        url: '/trips/getTrips',
      },
    ],
  },
  {
    category: true,
    title: 'Pasajeros',
  },
  {
    title: 'Pasajeros',
    key: 'pasajeros',
    icon: 'fa-regular fa-ticket',
    count: 3,
    children: [{
      title: 'Pasajeros',
      key: 'listaPasajeros',
      url: '/pasajeros',
    },
    {
      title: 'Carga de padrón',
      key: 'cargaLayout',
      url: '/usuarios-preferentes',
    },
    {
      title: 'Pasajeros Preferentes',
      key: 'pasajerosPreferentes',
      url: '/pasajerosPreferentes',
    },
    ],
  },
  {
    category: true,
    title: 'Historial de pagos',
  },
  {
    title: 'Historial de pagos',
    key: 'historial de pagos',
    icon: 'fa-solid fa-cash-register',
    count: 1,
    children: [{
      title: 'Historial de pagos',
      key: 'concesionarios',
      url: '/historialPagos/concesionarios',
    }],
  },
  {
    category: true,
    title: 'Tarifas',
  },
  {
    title: 'Tarifas',
    key: 'fares',
    icon: 'fa-regular fa-receipt',
    // cambiar a 4 luego de descomentar
    count: 4,
    children: [
      {
        title: 'Tarifa plana',
        key: 'rushHour',
        url: '/tarifasPlanas/registrarTarifaPlana',
      },
      {
        title: 'Tarifa Base',
        key: 'fares',
        url: '/montos/crearTarifa',
      },
      {
        title: 'Tarifa Base Municipio',
        key: 'municipalityfares',
        url: '/montos/tarifaBaseMunicipios',
      },
      {
        title: 'Saldo Minimo de Monedero',
        key: 'minBalance',
        url: '/montos/saldoMinimo',
      },
      {
        title: 'Tarifas tipos de vehículos',
        key: 'vehicleTypesFares',
        url: '/montos/TarifasTipoVehiculo',
      },
    ],
  },
  {
    category: true,
    title: 'Alertas botón de pánico',
  },
  {
    title: 'Alertas botón de pánico',
    key: 'alerts',
    icon: 'fa-solid fa-circle-exclamation',
    count: 2,
    children: [
      {
        title: 'Alertas del Conductor',
        key: 'emergencyDriver',
        url: '/emergencias/chofer',
      },
      {
        title: 'Alertas del Pasajero',
        key: 'emergencyPassenger',
        url: '/emergencias/pasajero',
      },
    ],
  },
  {
    category: true,
    title: 'Geocercas',
  },
  {
    title: 'Geocercas',
    key: 'geofences',
    icon: 'fa-regular fa-user',
    count: 2,
    children: [
      {
        title: 'Geocercas',
        key: 'getgeofences',
        url: '/geocercas/geocercas',
      },
      {
        title: 'Registrar Geocerca',
        key: 'registerGeofence',
        url: '/geocercas/registrar',
      },
    ],
  },
  {
    category: true,
    title: 'Sitios',
  },
  {
    title: 'Sitios',
    key: 'sites',
    icon: 'fa fa-building',
    count: 2,
    children: [
      {
        title: 'Sitios',
        key: 'getSites',
        url: '/sitios/sitios',
      },
      {
        title: 'Registrar sitios',
        key: 'registerSites',
        url: '/sitios/registrar-sitios',
      },
    ],
  },
  {
    category: true,
    title: 'Tarifas planas',
  },
  {
    title: 'Tarifas planas',
    key: 'fixedFares',
    icon: 'fa-regular fa-receipt',
    count: 6,
    children: [
      {
        title: 'Tarifas planas',
        key: 'getFixedFares',
        url: '/tarifasPlanas/tarifasPlanas',
      },
      {
        title: 'Registrar tarifa plana',
        key: 'registerFixedFare',
        url: '/tarifasPlanas/registrar',
      },
      {
        title: 'Destinos',
        key: 'getDestinations',
        url: '/tarifasPlanas/destinos',
      },
      {
        title: 'Registrar destinos',
        key: 'registerDestination',
        url: '/tarifasPlanas/registrarDestino',
      },
      {
        title: 'Origen tarifas planas',
        key: 'getAllsources',
        url: '/tarifasPlanas/origen',
      },
      {
        title: 'Registrar origen',
        key: 'registerOrigin',
        url: '/tarifasPlanas/registrarOrigen',
      },
    ],
  },
  /*
  {
    category: true,
    title: 'Renta',
  },
  {
    title: 'Renta',
    key: 'renta',
    icon: 'fa-regular fa-user',
    count: 1,
    children: [{
      title: 'Registrar Pago',
      key: 'registrarPago',
      url: '/renta/registrar',
    }],
  },
  */
  /*
  {
    category: true,
    title: 'Dashboards',
  },
  {
    title: '',
    key: 'dashboards',
    icon: 'fe fe-home',
    count: 4,
    children: [
      {
        title: '',
        key: 'dashboard',
        url: '/dashboard/alpha',
      },
    ],
  },
  {
    title: 'Auth Pages',
    key: 'auth',
    icon: 'fe fe-user',
    children: [
      {
        title: 'Login',
        key: 'authLogin',
        url: '/auth/login',
      },
      {
        title: 'Forgot Password',
        key: 'authForgotPassword',
        url: '/auth/forgot-password',
      },
      {
        title: 'Register',
        key: 'authRegister',
        url: '/auth/register',
      },
      {
        title: 'Lockscreen',
        key: 'authLockscreen',
        url: '/auth/lockscreen',
      },
      {
        title: 'Page 404',
        key: 'auth404',
        url: '/auth/404',
      },
      {
        title: 'Page 500',
        key: 'auth500',
        url: '/auth/500',
      },
    ],
  },
  */
]
